import getHtmlParam from '../../utilities/htmlParam';
import { quantityControls as quantity } from '../checkout/quantity';
import { addToCart } from "../checkout/addtocart";
import {updateWishlists, addToWishlist, openWishlistModal} from './towishlist';
import { fadeIn, fadeOut } from '../../utilities/helpers';
import {addEnterAndSpaceHandler} from "@utils/accessibility/general";
import {focusFirstFocusableElement} from "@utils/accessibility/modal";

let param = getHtmlParam('.js-param .param');
let currentStep = 0;
let currentPosition = 0;

export function initComparisonSidebar() {
  const reset = document.querySelector('.js-compare-reset') as HTMLElement;
  reset && reset.addEventListener('click', () => {
    event.preventDefault();
    resetComparison(reset.dataset.alert);
  });
  comparisonBadge();
}

export function addToComparison(target: Element) {
  let data;
  const article = target.closest('.product-element') as HTMLElement;
  const storage = JSON.parse(sessionStorage.getItem('article-comparison'));

  if (storage) {
    data = updateComparison(article.dataset.articleId, 'add');
  } else {
    data = {
      'ref': window.location.href,
      'articles': [article.dataset.articleId]
    }
  }

  sessionStorage.setItem('article-comparison', JSON.stringify(data));

  const sidebar = document.querySelector('.comparison-sidebar') as HTMLElement;
  if (sidebar) {
    openSidebar(sidebar, target as HTMLElement, data);
    updateBadgeCount();
    setLinkToComparison(target as HTMLElement);
  }
}

export function initComparison() {
  const page = document.querySelector('.product-comparison-view');
  if (!page) return;
  const storage = JSON.parse(sessionStorage.getItem('article-comparison'));
  const backToResult = document.querySelectorAll('.back-to-result, .head .page-back, .back-footer-btn');
  const addRow = document.querySelectorAll('.product-compare-add-cell');
  const table = document.getElementById('product-compare') as HTMLElement;
  backToResult.forEach((link: HTMLAnchorElement) => {
    if (storage && storage.ref) {
      link.href = storage.ref;
      !link.classList.contains('cta') && (link.style.display = 'flex');
      addRow.forEach((row: HTMLElement) => row.style.display = 'table-cell')
    }
  });
  if (storage && storage.articles.length === 0) {
    const infoBar: HTMLElement = document.querySelector('.product-compare-info');
    infoBar && (infoBar.style.display = 'none');
  }

  quantity('#product-compare', updatePrice);
  wishlist();

  const addToCartBtn = document.querySelectorAll('.add-to-basket');
  addToCartBtn.forEach((btn: HTMLElement) => {
    const id = btn.dataset.articleId;
    btn.addEventListener('click', () => {
      const image = btn.dataset.articleImg;
      const title = btn.dataset.articleTitle;
      const quantity = (btn.parentNode.querySelector('.pos-item-quantity') as HTMLInputElement).value;
      addToCart(btn, id, title, image, quantity);
    });
    // add price for tracking
    const priceWrapper: HTMLElement = document.querySelector('.article-price-' + id + ' .product-item-price-wrapper');
    btn.dataset.articlePrice = priceWrapper && priceWrapper.dataset.productPrice;
  });

  setComparisonIds(storage);

  const removeFromComparison = document.querySelectorAll('.remove-from-comparison');
  removeFromComparison.forEach((link: HTMLElement) => {
    link.addEventListener('click', () => {
      event.preventDefault();
      const data = updateComparison(link.dataset.articleId, 'remove');
      sessionStorage.setItem('article-comparison', JSON.stringify(data));
      window.location.href = '/product/comparison/articles?articleIds=' + data.articles.toString();
    });
  });

  const resetComparison = document.querySelector('.reset-comparison') as HTMLElement;
  resetComparison && resetComparison.addEventListener('click', () => {
    event.preventDefault();
    if (confirm(resetComparison.dataset.alert)) {
      const data = updateComparison('', 'clear');
      sessionStorage.setItem('article-comparison', JSON.stringify(data));

      window.location.href = '/product/comparison/articles?articleIds=';
    }
  });

  const showDiffs = document.querySelector('input.show-diffs');
  showDiffs && showDiffs.addEventListener('change', () => {
    table.classList.toggle('show-diffs');
  });

  const steps = document.querySelectorAll('.table-arrows span');
  steps.forEach((step: HTMLElement) => {
    step.addEventListener('click', () => {
      slideTable(step.dataset.direction, storage);
    });
  });

  window.addEventListener('keydown', (event) => {
    const key = event.key;
    slideTable(key, storage);
  });

  window.addEventListener('scroll', setStickyClass);

  const quantityInputs = table.querySelectorAll('.pos-item-quantity');
  quantityInputs.forEach((input: HTMLInputElement) => {
    input.addEventListener('focusout', () => {
      updatePrice(input.parentElement, input.value);
    });
  });
}

function updatePrice(el: Element, count: string) {
  const articleId = el.parentElement.dataset.articleId;
  const priceContainer = document.querySelector('.article-price-' + articleId);
  const noScaledPrice = priceContainer.querySelector('.no-scaled-price');
  if (noScaledPrice) return;
  window.fetch(param.get('urlPrefix') + '/pricing/article/' + articleId + '?quantity=' + count + '&profile=' + param.get('profile') + '&language=' + param.get('clientLocale') + '&legalCountry=' + param.get('legalCountry') + '&deliveryCountry=' + param.get('deliveryCountry') + '&identitySub=' + param.get('identitySub') + '&tenant=' + param.get('tenant') + '&username=' + param.get('identUsername') + '&isGuest=' + param.get('getIdentIsGuest') + '&type=comparison')
    .then((res) => {
      return res.text()
    })
    .then(html => {
      priceContainer && (priceContainer.innerHTML = html);
    })
  return false;
}

function setStickyClass() {
  const table: HTMLElement = document.querySelector('#product-compare');
  const header = document.querySelector('.head').clientHeight;
  // const header = 80;
  const offset = table.querySelector('thead').getBoundingClientRect().top;
  if (offset <= header) {
    table.parentElement.classList.add('stuck');
  } else {
    table.parentElement.classList.remove('stuck');
  }
}

function slideTable(direction: string, storage: Object | any) {
  const table: HTMLElement = document.querySelector('#product-compare');
  let articleCount = table.querySelectorAll('thead > tr:first-child > td').length - 2;
  storage && storage.ref && (articleCount = articleCount + 1);
  if (articleCount < 4) return;
  const cellWidth = 240;

  if (direction === 'ArrowRight' && currentStep <= articleCount - 4) {
    currentPosition = currentPosition - cellWidth;
    currentStep++;
  }

  if (direction === 'ArrowLeft' && currentStep > 0) {
    currentPosition = currentPosition + cellWidth;
    currentStep--;
  }
  table.style.transform = 'translateX(' + currentPosition + 'px)';


  const steps = document.querySelectorAll('#table-step-left, #table-step-right');

  if (currentStep > 0) {
    steps[0].classList.remove('inactive');
  } else {
    steps[0].classList.add('inactive');
  }

  if (currentStep === articleCount - 3) {
    steps[1].classList.add('inactive');
  } else {
    steps[1].classList.remove('inactive');
  }
}

function updateComparison(articleId: string, context: string) {
  const data = JSON.parse(sessionStorage.getItem('article-comparison'));
  if (context === 'add') {
    data.articles.indexOf(articleId) === -1
      && data.articles.push(articleId);
    data.ref = window.location.href;
  }
  if (context === 'remove') {
    data.articles.indexOf(articleId) !== -1
      && data.articles.splice(data.articles.indexOf(articleId), 1);
  }
  if (context === 'clear') {
    data.articles = [];
  }
  const button = document.querySelector('.sidebar-footer .js-compare') as HTMLAnchorElement;
  button && (button.href = '/product/comparison/articles?articleIds=' + data.articles.toString());
  return data;
}

function resetComparison(message: string) {
  if (confirm(message)) {
    sessionStorage.removeItem('article-comparison');
    const reset = document.querySelector('.js-compare-reset') as HTMLAnchorElement;
    const items = document.querySelector('.comparison-sidebar-items');
    const badge: HTMLElement = document.querySelector('.article-comparison-badge');
    items && (items.innerHTML = '');
    reset && (reset.href = '#');
    badge && (badge.style.display = 'none');
    fadeOut(document.querySelector('.modal-background'));
    const sidebar = document.querySelector('.comparison-sidebar') as HTMLElement;
    sidebar.style.display = 'none';
    document.body.removeAttribute('style');
  }
}

function setComparisonIds(storage: Object | any) {
  const param = window.location.search.split('articleIds=')[1];
  if (param === '') return;
  const articleIds = param.split(',');
  let data;
  if (storage) {
    storage.articles = articleIds;
    data = storage;
  } else {
    data = {
      'articles': articleIds
    }
  }
  sessionStorage.setItem('article-comparison', JSON.stringify(data));
}

function openSidebar(sidebar: HTMLElement, triggerElement?: HTMLElement, data?: object | any) {
  if (triggerElement && !triggerElement.id) {
    // Generate unique ID if none exists
    triggerElement.id = 'trigger-' + Math.random().toString(36).substring(2, 9);
  }
  sidebar.dataset.triggerElementId = triggerElement?.id || '';

  !data && (data = JSON.parse(sessionStorage.getItem('article-comparison'))); 
  const button = sidebar.querySelector('.js-compare') as HTMLAnchorElement;
  button.href = '/product/comparison/articles?articleIds=' + data.articles.toString();
  sidebar.style.display = 'flex';
  loadSidebarContent();
  addEnterAndSpaceHandler()
  updateStorageRef(data);
  fadeIn(document.querySelector('.modal-background'));
  document.body.style.overflow = 'hidden';

  const focusTrigger = () => {
    // jump back to trigger
    const triggerId = sidebar.dataset.triggerElementId;
    if (triggerId) {
      const triggerElement = document.getElementById(triggerId);
      if (triggerElement) {
        // Small timeout helps with some screen readers
        setTimeout(() => triggerElement.focus(), 50);
      } else {
        console.warn(`Trigger element with ID ${triggerId} not found`);
        // focusFallback();
      }
    } else {
      // focusFallback();
    }
  }

  const sidebarClick = (e: Event) => {
    const thisEl = e.target as HTMLElement;
    if (thisEl.closest('.sidebar-close') || thisEl.className === 'modal-background') {
      fadeOut(document.querySelector('.modal-background'));
      sidebar.style.display = 'none';
      focusTrigger()
      document.body.removeAttribute('style');
      window.removeEventListener('click', sidebarClick);
    }

    sidebar.addEventListener("keydown", (event)=>{
      if(event.key === "Escape"){
        fadeOut(document.querySelector('.modal-background'));
        // copied from click handler, should be moved to a close function instead
        const sidebar = document.querySelector('.comparison-sidebar') as HTMLElement;
        sidebar.style.display = 'none';
        focusTrigger()
      }
    })
    if (thisEl.className === 'remove-from-comparison') {
      thisEl.closest('.article-item').parentNode.removeChild(thisEl.closest('.article-item'));
      const data = updateComparison(thisEl.dataset.articleId, 'remove');
      sessionStorage.setItem('article-comparison', JSON.stringify(data));
      updateBadgeCount();
    }
  };

  window.addEventListener('click', sidebarClick);
  //focus close button
  focusFirstFocusableElement(sidebar)
}

function loadSidebarContent() {
  const storage = JSON.parse(sessionStorage.getItem('article-comparison'));
  window.fetch(param.get('urlPrefix') + '/product/article/list?articleIds=' + storage.articles.join() + '&layout=layout')
    .then((res) => {
      return res.text()
    })
    .then((html: string) => {
      const sidebarContent = document.querySelector('.comparison-sidebar-items');
      sidebarContent && (sidebarContent.innerHTML = html);
      // set price to title for tracking
      setTimeout(() => {
        const dataPrices = sidebarContent.querySelectorAll('[data-price]');
        dataPrices.forEach((item: HTMLElement) => {
          const sidebar = item.closest('.product-tile-side');
          sidebar && ((sidebar.querySelector('.product-title a') as HTMLElement).dataset.price = item.dataset.price);
        });
        addEnterAndSpaceHandler()
      }, 0);
    })
}

function comparisonBadge() {
  const badge: HTMLElement = document.querySelector('.article-comparison-badge');
  if (badge) {
    const sidebar = document.querySelector('.comparison-sidebar') as HTMLElement;
    sidebar && badge.addEventListener('click', () => openSidebar(sidebar, badge));
  }

  const storage = JSON.parse(sessionStorage.getItem('article-comparison'));
  if (!storage || !storage.articles.length || storage.articles[0] === '') return;
  if (badge) {
    const count = storage.articles.length;
    badge.dataset.articleCount = storage.articles[0] === '' ? '0' : count;
    badge.style.display = 'flex';
  }
}

function updateBadgeCount() {
  const storage = JSON.parse(sessionStorage.getItem('article-comparison'));
  const badge: HTMLElement = document.querySelector('.article-comparison-badge');
  if (badge) {
    const count = storage.articles.length;
    badge.dataset.articleCount = storage.articles[0] === '' ? '0' : count;
    badge.style.display = 'flex';
    !count && (badge.style.display = 'none');
  }
}

function updateStorageRef(storage: Object | any) {
  storage.ref = window.location.href;
  sessionStorage.setItem('article-comparison', JSON.stringify(storage));
}

function wishlist() {
  const toWishlist: Array<HTMLElement> = Array.from(document.querySelectorAll('.article-to-wishlist'));
  let pid: string, aid: string;
  toWishlist.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      aid = btn.dataset.articleId;
      pid = btn.dataset.productId;

      updateWishlists('compare', btn);
      openWishlistModal('compare', pid, aid, true) //dont update wishlists, as it is already done manually
    });
  });

  const addToWishlistBtn = document.querySelector('.add-to-wishlist');
  addToWishlistBtn && addToWishlistBtn.addEventListener('click', (e) => {
    e.preventDefault();
    addToWishlist('pues', aid, pid);
  });
}

function setLinkToComparison(compareBtn: HTMLElement) {
  const MP = compareBtn.dataset.addedMp;
  if (!MP) return;
  const addedBtn = document.createElement('span');
  const icon = document.createElement('i');
  icon.classList.add('uil', 'uil-arrow-right')
  addedBtn.classList.add('added-to-compare');
  addedBtn.setAttribute('tabindex', '0');
  addedBtn.setAttribute('role', 'button');
  addedBtn.id = compareBtn.id
  //addedBtn.innerHTML = MP + '<svg><use xlink:href="#arrow-v3"/></svg>';
  addedBtn.innerHTML = MP;
  addedBtn.appendChild(icon);
  compareBtn.parentNode.replaceChild(addedBtn, compareBtn);
  addEnterAndSpaceHandler()//attach enter and space listener
}
